<template>
    <div class="card">
        <div class="card-body black-text-color">
            <div class="row">
                <div class="col-12">
                    <div>
                        <h5 class="bold boldText">{{ lang('idpal_upload_document_title') }}</h5>
                        <p>
                            <span v-html="lang('idpal_upload_document_text')"></span>
                            <span v-if="!!getTooltipText('idpal_required_documents')"
                                  :title="lang('send_id_pal_link')"
                                  :data-bs-content="getTooltipText('idpal_required_documents')"
                                  class="helpBtn addPopover helpHeader">
                                                 <i tabindex="-1" class="fa fa-info-circle"></i>
                                        </span>
                        </p>

                        <div v-if="signerHasPhoneNumber">
                            <h6 class="bold boldText">{{lang('contact_details')}}</h6>
                            <p class="mb-2">{{ownerContact}}</p>
                            <button  type="button" href="#" class="btn btn-default btn--idpal-upload" @click="getIdPalLink">
                                {{ idPalButtonText }}
                            </button>
                        </div>
                        <np-notice v-else :dismissable="false" :notice="lang('please_provide_valid_phone_number_for_idpal')"> </np-notice>
                    </div>
                    <template v-if="isDocumentUploadWorkflowConfigured">
                        <p class="my-3 bold boldText text-uppercase">{{ lang('or') }}</p>
                        <div class="section-smaller">
                            <h5 class="bold boldText"> {{ lang('upload_document_manually') }}</h5>
                            <button type="button"
                                    href="#" class="btn btn-default my-2 btn--idpal-upload" @click="emitUseDocumentUpoad">
                                {{ lang('continue_to_document_upload') }}
                            </button>
                            <p class=" mt-3 fw-bold">{{ lang('document_upload_help_suffix') }}</p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import {NPNotice} from "../netpify/components";

export default {
    //TODO this can work some other time. Needs a lot of reworking to pass the needed props and emit the right data
    name: "id-pal-verify",
    components: {
        'np-notice': NPNotice,
    },
    props: {
        signerOwner: {
            default: {}
        },
        merchant: {
            default: {}
        },
        mode: {
            default: 'edit'
        },
        isDocumentUploadWorkflowConfigured: Boolean,
        ownerContact: '',
        parameters: {
            default: {}
        },

    },
    computed: {
        idPalButtonText: function () {
            return this.signerOwner.idpal_verification === '1' && this.signerOwner.idpal_uuid !== '' ?
                this.lang('resend_id_pal_link') : this.lang('send_id_pal_link') ;
        },
        signerHasPhoneNumber: function (){
            //check that it exists and matches numeric validation
            return !!this.signerOwner.owner_phone_no && /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(this.signerOwner.owner_phone_no)
        }
    },
    methods: {
        getIdPalLink: function () {
            let payload = {
                'application_reference': this.merchant.application_reference,
                'owner_ref': this.signerOwner.owner_ref,
            }

            let vm = this;
            vm.showPreloader = true;

            this.getAxiosInstance().post('/externalservices/getidpallink', payload)
                .then(response => {
                    vm.showPreloader = false;
                    // console.log(response)
                    if (response.data.result === 'SUCCESS') {
                        vm.notifySuccess(vm.lang('idpal_link_sent_successfully'))
                        const {idpal} = response.data;
                        vm.emitIdPalSuccess(idpal)
                    }
                })
                .catch(error => {
                    vm.showPreloader = false;
                    vm.notifyError(error)
                });
        },
        emitIdPalSuccess: function (response) {
            //TODO update signer principal
            this.$emit('success-callback', response)
        },
        emitUseDocumentUpoad: function () {
            this.$emit('use-doc-upload');
        }
    }
}
</script>

<style scoped>
.black-text-color{
    color: black;
}

.btn--idpal-upload {
    background-color: #2C7BBC !important;
}

.section-smaller p, .section-smaller button{
    font-size: 12px !important;
}

.section-smaller h5{
    font-size: 1rem !important;
}
</style>
